




















import { defineComponent, ref, Ref, toRefs, watch } from '@vue/composition-api'

export default defineComponent({
  props: {
    value: String,
    disabled: Boolean,
  },
  setup: (props, ctx) => {
    const dialog = ref(null) as Ref<
      null | (Vue & { save: (time: string) => void })
    >
    const modal = ref(false)
    const time = ref(props.value)

    const { value } = toRefs(props)

    watch(
      () => time.value,
      value => ctx.emit('input', value),
    )

    watch(
      () => value?.value,
      value => (time.value = value),
    )

    return {
      dialog,
      modal,
      time,
    }
  },
})
